<template>
  <div>
    <div class="e-card">
        <div class="e-card-content">
            <font-awesome-icon :icon="icon" class="fa-icon-element"/>
            <p v-for="(item, index) in textLines" :key="index" class="item-container">
              <span
                v-if="item.type === 'title'
                  || item.type === 'subtitle'
                  || item.type === 'content-text'
                  || item.type === 'empty'"
                class="item-content"
                :class="{
                  'text-bold': item.type === 'title',
                  'text-italic': item.type === 'subtitle',
                  'text-content': item.type === 'content-text',
                }"
              >
                {{ item.value }}
              </span>
              <a
                v-if="item.type === 'content-link'"
                class="text-content"
                :href="`mailto:${item.value}`"
              >
                {{ item.value }}
              </a>
            </p>
        </div>
    </div>
  </div>
</template>

<script>
/*
  icon is array of font awesome properties; for example ['fas', 'envelope']
  textLines ia array of objectts with type and value properties, where type can be:
    'title', 'subtitle', 'empty', 'content-text', 'content-link'
*/
export default {
  name: 'AppInfoThumbnail',
  props: {
    icon: { type: Array, default: () => [] },
    textLines: { type: Array, default: () => [] },
  },
};

</script>

<style scoped>

.e-card-content{
  text-align: left;
  padding-left:5px;
  padding-top:5px;
  padding-bottom:5px;
  margin: 5px;
}
.fa-icon-element{
  font-size: 25px;
  color:#0f4b90;
}
.item-container {
  margin: 0;
  padding: 0;
}
.item-content {
  display: inline-block
}
.text-bold {
  font-weight: bold;
}
.text-italic {
  font-style: italic;
}
</style>
